import { EmailToPatient, PatientControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 *
 * @author Rajkumar Rathod
 */
export const useSendSmsToPatient = () =>
  useMutationWithLoading(
    async (params: { emailToPatient: EmailToPatient; xTENANTID?: string }) =>
      new PatientControllerApi(getConfigObject()).sendSMSToPatientId(
        params?.emailToPatient,
        params?.xTENANTID
      )
  );
